import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-header-abastecimento',
  standalone: false,
  templateUrl: './header-abastecimento.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header-abastecimento.component.css'
})
export class HeaderAbastecimentoComponent {
   mostrarMensagem = false;

  compartilharPagina() {
    this.mostrarMensagem = true;

    // Opcional: esconder mensagem após 3 segundos
    setTimeout(() => {
      this.mostrarMensagem = false;
    }, 3000);
  }
} 
